// MessageBox.tsx
import React from "react";
import { createPortal } from "react-dom";

interface MessageBoxProps {
  message: string;
  onClose: () => void;
  icon?: React.ReactNode; // Nova propriedade opcional para o �cone
}

const MessageBox: React.FC<MessageBoxProps> = ({ message, icon, onClose }) => {
  if (typeof document === "undefined") return null;

  return createPortal(
    <div className="fixed inset-0 z-[2147483647] flex items-center justify-center bg-gray-900 bg-opacity-50">
      <div className="relative z-[2147483647] bg-white p-6 rounded-lg">
        {icon && <div className="mb-4">{icon}</div>}
        <div className="text-xl">{message}</div>
        <button
          onClick={onClose}
          className="mt-4 bg-indigo-600 text-white px-4 py-2 rounded-md hover:bg-indigo-500"
        >
          Fechar
        </button>
      </div>
    </div>,
    document.body
  );
};

export default MessageBox;
